import { SortDir } from '@ui/src';

export const geographicalRiskColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'name',
    label: 'Country Name',
  },
  {
    name: 'alpha3',
    label: 'Country code',
  },
  {
    name: 'riskScore',
    label: 'Risk score',
  },
];

export const geographicalRiskDefaultSorter = {
  sortProp: geographicalRiskColumns[1].name,
  sortDir: SortDir.ASC,
};

export const geographicalRiskSchema = {};
export const geographicalRiskFiltersSchema = [];
